import React from "reactn";
import { Card, CardBody, CardHeader, Badge } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { Link } from "react-router-dom";

class TicketRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: "",
      message: "",
      priority: "low",
      userId: "",
      submitting: false,
      attachments: [],
      previewImages: [],
      tickets: [],
      loadingTickets: false,
      connections: [],
      loadingConnections: false,
      connectionSearch: "",
      showConnectionDropdown: false
    };

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Support Service", to: "/ticket-requests" }
      ]
    });
  }

  componentDidMount() {
    this.loadTicketHistory();
    this.loadConnections();
  }

  loadTicketHistory = async () => {
    this.setState({ loadingTickets: true });
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/partners/ticket-requests`
      );

      if (response.data.success) {
        this.setState({ tickets: response.data.data });
      } else {
        console.error("Failed to load tickets:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading tickets:", error);
    } finally {
      this.setState({ loadingTickets: false });
    }
  };

  loadConnections = async () => {
    this.setState({ loadingConnections: true });
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/partners/connections/true`
      );

      if (response.data.success) {
        const connections = response.data.data.connections;
        const activeConnections = connections
          .filter(f => !f.isArchived && f.classification === "active")
          .map(connection => ({
            dsUserId: connection.dsUserId,
            displayName: connection.displayName,
            email: connection.email,
            childNames: connection.childNames || []
          }));
        
        this.setState({ connections: activeConnections });
      } else {
        console.error("Failed to load connections:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading connections:", error);
    } finally {
      this.setState({ loadingConnections: false });
    }
  };

  handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => 
      file.type.startsWith('image/') && file.size <= 5 * 1024 * 1024 // 5MB limit
    );

    if (validFiles.length !== files.length) {
      toast.warning("Some files were skipped. Only images under 5MB are allowed.");
    }

    // Create preview URLs
    const newPreviewImages = validFiles.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    this.setState(prevState => ({
      attachments: [...prevState.attachments, ...validFiles],
      previewImages: [...prevState.previewImages, ...newPreviewImages]
    }));
  };

  removeImage = (index) => {
    this.setState(prevState => {
      const newAttachments = [...prevState.attachments];
      const newPreviewImages = [...prevState.previewImages];
      
      // Revoke the object URL to prevent memory leaks
      URL.revokeObjectURL(newPreviewImages[index].preview);
      
      newAttachments.splice(index, 1);
      newPreviewImages.splice(index, 1);
      
      return {
        attachments: newAttachments,
        previewImages: newPreviewImages
      };
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitting: true });

    try {
      const formData = new FormData();
      formData.append('subject', this.state.subject);
      formData.append('message', this.state.message);
      formData.append('priority', this.state.priority);
      formData.append('userId', this.state.userId);

      this.state.attachments.forEach((file, index) => {
        formData.append(`attachments`, file);
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API}/partners/ticket-requests`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        toast.success("Support ticket submitted successfully!");
        this.setState({
          subject: "",
          message: "",
          priority: "low",
          userId: "",
          attachments: [],
          previewImages: []
        });
        this.loadTicketHistory();
      } else {
        toast.error(response.data.message || "Failed to submit ticket. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      this.setState({ submitting: false });
    }
  };

  getPriorityBadgeColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'danger';
      case 'high':
        return 'warning';
      case 'medium':
        return 'info';
      case 'low':
        return 'secondary';
      default:
        return 'secondary';
    }
  };

  getStatusBadgeColor = (status) => {
    switch (status) {
      case 'open':
        return 'success'; 
      case 'in_progress':
        return 'warning';
      case 'resolved':
        return 'success';
      case 'closed':
        return 'secondary';
      default:
        return 'secondary';
    }
  };

  formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  componentWillUnmount() {
    this.state.previewImages.forEach(image => {
      URL.revokeObjectURL(image.preview);
    });
  }

  render() {
    const filteredConnections = this.state.connections.filter(connection =>
      connection.displayName.toLowerCase().includes(this.state.connectionSearch.toLowerCase()) ||
      connection.email.toLowerCase().includes(this.state.connectionSearch.toLowerCase())
    );

    return (
      <div className="container-fluid adminprofiles">
        <div className="cont">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray-800">Support Service</h1>
          </div>

          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <Card className="shadow mb-4">
                <CardHeader className="py-3 d-flex flex-row align-items-center justify-content-between">
                  <h6 className="m-0 font-weight-bold" style={{ color: '#3B4EFF' }}>
                    Submit a Support Request
                  </h6>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="subject" className="font-weight-bold">
                        Subject <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        value={this.state.subject}
                        onChange={(e) => this.setState({ subject: e.target.value })}
                        required
                        placeholder="Brief description of your issue"
                        style={{ fontSize: '0.9rem' }}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="priority" className="font-weight-bold">
                        Priority <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        id="priority"
                        value={this.state.priority}
                        onChange={(e) => this.setState({ priority: e.target.value })}
                        required
                        style={{ fontSize: '0.9rem' }}
                      >
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                        <option value="urgent">Urgent</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message" className="font-weight-bold">
                        Message <span style={{ color: 'red' }}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        rows="10" 
                        value={this.state.message}
                        onChange={(e) => this.setState({ message: e.target.value })}
                        required
                        maxLength="10000" 
                        placeholder="Please provide detailed information about your issue..."
                        style={{ fontSize: '0.9rem' }}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="connection" className="font-weight-bold">
                        Parent/Child
                      </label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search connections associated with your issue..."
                          value={this.state.connectionSearch}
                          onChange={(e) => this.setState({ connectionSearch: e.target.value })}
                          onFocus={() => this.setState({ showConnectionDropdown: true })}
                          style={{ fontSize: '0.9rem' }}
                        />
                        {this.state.showConnectionDropdown && (
                          <div 
                            className="position-absolute w-100 bg-white border rounded shadow-sm"
                            style={{ 
                              zIndex: 1000, 
                              maxHeight: '200px', 
                              overflowY: 'auto',
                              top: '100%',
                              left: 0
                            }}
                          >
                            <div 
                              className="p-2 border-bottom"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                this.setState({ 
                                  userId: "", 
                                  connectionSearch: "",
                                  showConnectionDropdown: false 
                                });
                              }}
                            >
                              <small className="text-muted">Clear selection</small>
                            </div>
                            {filteredConnections.map((connection) => (
                              <div
                                key={connection.dsUserId}
                                className="p-2 border-bottom"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  this.setState({ 
                                    userId: connection.dsUserId,
                                    connectionSearch: connection.displayName,
                                    showConnectionDropdown: false 
                                  });
                                }}
                              >
                                <div className="font-weight-bold">{connection.displayName}</div>
                                <small className="text-muted">{connection.email}</small>
                                {connection.childNames.length > 0 && (
                                  <div className="text-muted">
                                    <small>Children: {connection.childNames.map(child => child.fullName).join(', ')}</small>
                                  </div>
                                )}
                              </div>
                            ))}
                            {filteredConnections.length === 0 && (
                              <div className="p-2 text-muted">
                                <small>No connections found</small>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="attachments" className="font-weight-bold">Attachments</label>
                      <input
                        type="file"
                        className="form-control-file"
                        id="attachments"
                        multiple
                        accept="image/*"
                        onChange={this.handleFileSelect}
                        style={{ 
                          width: 'auto',
                          padding: '4px 8px',
                          fontSize: '0.9rem',
                          backgroundColor: '#f8f9fa'
                        }}
                      />
                      <small className="form-text text-muted" style={{ marginTop: '8px', display: 'block', fontSize: '0.85rem' }}>
                        Please attach images to help us better understand your issue. 
                      </small>
                    </div>

                    {this.state.previewImages.length > 0 && (
                      <div className="form-group">
                        <label>Attached Images:</label>
                        <div className="row">
                          {this.state.previewImages.map((image, index) => (
                            <div key={index} className="col-md-3 mb-2">
                              <div className="position-relative">
                                <img
                                  src={image.preview}
                                  alt={`Preview ${index + 1}`}
                                  className="img-thumbnail"
                                  style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute"
                                  style={{ top: '5px', right: '5px' }}
                                  onClick={() => this.removeImage(index)}
                                >
                                  ×
                                </button>
                              </div>
                              <small className="text-muted d-block mt-1">
                                {image.file.name}
                              </small>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="btn btn-success"
                      disabled={this.state.submitting}
                      style={{ 
                        backgroundColor: '#28a745', 
                        borderColor: '#28a745',
                        color: 'white',
                        padding: '0.375rem 0.75rem',
                        fontSize: '0.875rem',
                        borderRadius: '13px'
                      }}
                    >
                      {this.state.submitting ? "Submitting..." : "Submit Ticket"}
                    </button>
                  </form>
                </CardBody>
              </Card>

              <Card className="shadow mb-4">
                <CardHeader className="py-3 d-flex flex-row align-items-center justify-content-between">
                  <h6 className="m-0 font-weight-bold" style={{ color: '#3B4EFF' }}>
                    Ticket History
                  </h6>
                  <button 
                    className="btn btn-outline-primary"
                    onClick={this.loadTicketHistory}
                    disabled={this.state.loadingTickets}
                    style={{ 
                      padding: '0.375rem 0.75rem', 
                      fontSize: '0.875rem',
                      borderRadius: '13px'
                    }}
                  >
                    {this.state.loadingTickets ? "Loading..." : "Refresh"}
                  </button>
                </CardHeader>
                <CardBody>
                  {this.state.loadingTickets ? (
                    <div className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : this.state.tickets.length === 0 ? (
                    <div className="text-center text-muted">
                      <p>No tickets found. Submit your first support request above.</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Ticket ID</th>
                            <th>Subject</th>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th>Updated</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.tickets.map((ticket) => (
                            <tr key={ticket.id}>
                              <td>
                                <strong>#{ticket.id}</strong>
                              </td>
                              <td>
                                <div>
                                  <strong>{ticket.subject}</strong>
                                  <br />
                                  <small className="text-muted">
                                    {ticket.message.length > 100 
                                      ? `${ticket.message.substring(0, 100)}...` 
                                      : ticket.message
                                    }
                                  </small>
                                </div>
                              </td>
                              <td>
                                <Badge color={this.getPriorityBadgeColor(ticket.priority)} style={{ padding: '0.5rem 0.75rem' }}>
                                  <small className="font-weight-bold" style={{ color: '#000' }}>{ticket.priority.toUpperCase()}</small>
                                </Badge>
                              </td>
                              <td>
                                <Badge color={this.getStatusBadgeColor(ticket.status)} style={{ padding: '0.5rem 0.75rem' }}>
                                  <small className="font-weight-bold" style={{ color: '#000' }}>{ticket.status.replace('_', ' ').toUpperCase()}</small>
                                </Badge>
                              </td>
                              <td>
                                <small>{this.formatDate(ticket.createdAt)}</small>
                              </td>
                              <td>
                                <small>{this.formatDate(ticket.updatedAt)}</small>
                              </td>
                              <td>
                                <Link 
                                  to={`/partners/ticket-requests/${ticket.id}`}
                                  className="btn btn-info"
                                  style={{ 
                                    padding: '0.25rem 0.5rem', 
                                    fontSize: '0.8rem',
                                    backgroundColor: '#17a2b8',
                                    borderColor: '#17a2b8',
                                    color: 'white'
                                  }}
                                >
                                  View Details
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }


}

export default TicketRequests;